import { render, staticRenderFns } from "./SupplierManualPurchasingPricesComponent.vue?vue&type=template&id=72090249&"
import script from "./SupplierManualPurchasingPricesComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierManualPurchasingPricesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports